<template>
    <div>
        <v-overlay absolute v-bind:value="KSurveyProps.processing">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-main fluid class="mt-n6">
            <div>
                <v-form ref="form"
                        v-model="valid"
                        class="w-100">

                    <v-container v-show="GetWhatToShow == 'view'" class="w-100 pa-8">
                        <kview form="degerlendirme"
                               v-bind:viewname="GetViewName"
                               v-on:rowclicked="ViewClicked($event, 'view')"></kview>
                    </v-container>
                    <v-container v-show="GetWhatToShow != 'view'" fluid class="pa-8">
                        <v-btn text tile color="primary" v-on:click="BackToView">
                            <v-icon left>mdi-arrow-left</v-icon>{{$t("AL_Back")}}
                        </v-btn>
                        <v-row>
                            <v-col class="pb-0 mb-0">
                                <dynoform header="Değerlendirmelerim"
                                          v-on:change="UpdateFormField($event, 'formdata')"
                                          v-on:changeGrid="UpdateExtData($event, $event.tableName)"
                                          v-on:click="FormButtonClicked($event)"
                                          v-bind:attributes="GetFormAttributes"
                                          v-on:SearchInputChanged="SearchInputChanged($event, 'formdata')"
                                          v-bind:tabname="Math.random().toString()">
                                    <template v-slot:KSurvey>
                                        <KSurvey v-bind:questions="KSurveyData" v-bind:props="KSurveyProps" />
                                    </template>
                                </dynoform>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
                <v-dialog v-model="actionBarWait"
                          persistent>
                    <v-card color="transparent"
                            dark class="py-5">
                        <v-card-text class="text-center py-5">
                            <v-progress-circular indeterminate
                                                 v-bind:size="50"
                                                 color="white"></v-progress-circular>
                        </v-card-text>
                    </v-card>
                </v-dialog>
            </div>
            <v-footer class="grey lighten-3 pa-3" inset app padless>
                <v-progress-circular v-if="actionBarWait" v-bind:size="20" v-bind:width="2" rounded indeterminate color="primary" class="my-2 mr-2"></v-progress-circular>
                <v-toolbar-title v-if="actionBarWait" class="primary--text overline">{{$t("IM_YourTransactionIsInProgress")}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn v-show="GetWhatToShow != 'view'" v-for="(actionInfo, index) in GetFormAction"
                       v-bind:loading="actionBarWait"
                       v-on:click="ApprovedAction(actionInfo)"
                       depressed
                       class="mx-2 px-10 primary darken-1 white--text font-weight-medium text-capitalize"
                       v-bind:class="index == GetFormAction.length - 1 ? 'primary' : 'secondary'"
                       v-bind:key="actionInfo.action">
                    {{ $t(actionInfo.label) }}
                </v-btn>
            </v-footer>
        </v-main>
    </div>
</template>

<style>
    .grey-lighten-4 {
        background-color: #f5f5f5;
    }

    .v-dialog {
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
    }
</style>

<script>

    import Vue from 'vue';
    import Vuex from 'vuex';
    Vue.use(Vuex);
    import KSurvey from '@/components/KSurvey.vue';
    import dynoform from '@/components/DynoForm.vue';
    import leftmenu from '@/components/leftmenu.vue';
    import showdialog from '@/components/ShowDialog.vue';
    import kview from '@/components/view.vue';
    import 'material-design-icons-iconfont/dist/material-design-icons.css';
    import { FormMixIn } from '@/MixIns/FormMixins';


    var KSurvey_Cevaplar =
    {
        tableName: 'KSurvey_Cevaplar',
        header: '',
        columns: {
            rowid: {
                type: 'text',
                label: 'Sira',
                edit: '',
                name: 'rowid'
            },
            id: {
                type: 'hidden',
                label: 'id',
                edit: '',
                name: 'id',
                width: 0
            },
            originformno: {
                type: 'hidden',
                label: 'originformno',
                edit: '',
                name: 'originformno',
                width: 0
            },
            cevap: {
                type: 'hidden',
                label: 'cevap',
                edit: '',
                name: 'cevap',
                width: 0
            },
            baglisoruid: {
                type: 'hidden',
                label: 'baglisoruid',
                edit: '',
                name: 'baglisoruid',
                width: 0
            },
            baglisecenek: {
                type: 'hidden',
                label: 'baglisecenek',
                edit: '',
                name: 'baglisecenek',
                width: 0
            },
            tip: {
                type: 'hidden',
                label: 'tip',
                edit: '',
                name: 'tip',
                width: 0
            },
            secenekler: {
                type: 'hidden',
                label: 'secenekler',
                edit: '',
                name: 'secenekler',
                width: 0
            },
        },
        extdatainfo: {
            id: 'id', //Parent table id
            ident: 'originformno', //child id or foreinkey
            formField1: '',
            formFieldValue1: '',
            formField2: '',
            formFieldValue2: '',
            xtableName: '',
            queryName: 'GETKSurveyCevaplar'
        },
        parameters: ['*id'],
        attributes: {},
        data: [],
        loaded: false,
        loading: false
    };

    var degerlendirme_formInfo = {
        tabs: [
            {
                order: 1,
                header: 'FN_Assessment'
            },
        ],
        groups: [
            {
                tab: 1,
                order: 1,
                header: 'TH_FormInformation'
            },
            {
                tab: 1,
                order: 2,
                header: 'TH_AssessmentQuestions',
                slotName: "KSurvey"
            }
        ],

        Columns: {
            id: {
                type: 'hidden',
                label: 'id',
                edit: '',
                name: 'id',
                width: 0
            },

            FormNumarasi: {
                type: 'text',
                group: 1,
                sira: 10,
                name: 'FormNumarasi',
                label: 'FL_FormNo',
                edit: '',
                col: '6',
            },

            durum: {
                type: 'text',
                group: 1,
                sira: 20,
                name: 'durum',
                label: 'FL_Status',
                edit: '',
                col: '6',
            },

            konu: {
                type: 'textarea',
                group: 1,
                sira: 30,
                name: 'konu',
                label: 'FL_Subject',
                edit: '',
                col: '12',
            },
        },
        form: 'degerlendirme',
        formid: 0,
        viewName: 'benim',
        viewparameter: '',
        ignoreActions: true,
        files: [],
        extdata: [
            KSurvey_Cevaplar
        ],
        actions: [],
        parameters: [],
        attributes: {}
    };

    export default {
        name: 'degerlendirme',
        mixins: [FormMixIn],
        components: {
            KSurvey,
            dynoform,
            leftmenu,
            kview,
            showdialog
        },
        props: {
            formid: [Number, String],
            view: String,
            message: Object
        },
        data: function ()
        {
            return {
                KSurveyData: [],
                KSurveyProps: {
                    processing: false,
                    editable: true
                },
                valid: false,
                messages: { messageType: '', messageBody: '', infoBody: '', viewType: '' },
                viewName: 'benim',
                username: '',
                form: '',
                formname: 'degerlendirme',
                openallpanel: [0],
                currentform: 'degerlendirme',
                errors: []
            };
        },
        methods: {
            FormLoaded: function ()
            {
                const self = this;
                const state = self.GetFormState;

                const formActions = [];

                if (["A"].includes(state))
                {
                    formActions.push({ label: 'Kaydet', action: 'TKaydet', type: 'external' });
                    formActions.push({ label: 'Cevapları Bankaya İlet', action: 'TCevapla', type: 'external' });
                }

                self.$store.commit('SetFormActions', formActions);
            },

            ExtDataLoaded: function (tableName)
            {
                const self = this;

                const state = self.GetFormState;

                switch (tableName)
                {
                    case "KSurvey_Cevaplar":
                        self.KSurveyProps.editable = ["A"].includes(state);
                        self.KSurveyData = self.GetExdataItems(tableName);
                        break;
                    default:
                        break;
                }
            },

            Selected: function ()
            {
                return;
            },

            NeedApprove: function (action)
            {
                const self = this;

                const state = self.GetFormState;

                if (["A"].includes(state))
                {
                    switch (action)
                    {
                        case "TKaydet":
                            let msg = self.$root.$i18n.t("Anket soruları üzerindeki cevaplar daha sonrasında tamamlanmak üzere sisteme kaydedilecektir ancak <strong>bankaya iletilmeyecektir.</strong> Cevaplarınızı bankaya iletmek için <u>\"{0}\"</u> aksiyonu almanız gerekmektedir. İşleme devam etmek istiyor musunuz?");

                            return msg.replace("{0}", self.$root.$i18n.t("Cevapları Bankaya İlet"));
                            break;
                        case "TCevapla":
                            return self.$root.$i18n.t("Anket soruları üzerindeki cevaplar sisteme kaydedilecek olup Bankaya iletilecek ve ilgili ekiplere bilgilendirme yapılacaktır. <strong>Bu aşamadan sonra cevaplarınızı değiştiremeyeceksiniz</strong>. İşleme devam etmek istiyor musunuz?")
                            break;
                        default:
                            return '';
                    }
                }

                return '';
            },

            FormButtonClicked(col)
            {
                console.log("FormButtonClicked", col);
            },

            RowClicked: function (rowdata, table)
            {

            },

            RowButtonClicked: function (payload, tableName)
            {

            },

            ChangeAttribute: function (attribute, tableName)
            {
                this.$store.commit('SetFieldAttributes', { ...attribute, tableName });
            },
            ValidateForm: function (actionInfo)
            {
                const self = this;
                const state = self.GetFormState;
                const action = actionInfo.action
                const errors = [];

                self.ClearFieldErrors();

                if (["A"].includes(state))
                {
                    let isAllQuestionsAnswered = true;
                    const allowUnanswered = action == "TKaydet";

                    for (const question of self.KSurveyData)
                    {
                        question.error = false;

                        const isAnswered = question.cevap.length > 0;

                        if (allowUnanswered && !isAnswered)
                        {
                            continue;
                        }

                        const isQuestionIsMandatory = Number(question.zorunlu);

                        if (isQuestionIsMandatory)
                        {
                            const bagliSoruId = Number(question.baglisoruid);
                            const isParentQuestion = bagliSoruId == 0;

                            if (isParentQuestion)
                            {
                                if (!isAnswered)
                                {
                                    isAllQuestionsAnswered = false;
                                    question.error = true;
                                }
                            }
                            else
                            {
                                const parentQuestion = self.KSurveyData.find(q => q.id === bagliSoruId);

                                let isParentQuestionAnswerRequireTheCurrentQuestionToBeAnswered;

                                switch (parentQuestion.tip)
                                {
                                    case "radio":
                                        isParentQuestionAnswerRequireTheCurrentQuestionToBeAnswered = parentQuestion.cevap === question.baglisecenek;
                                        break;
                                    case "checkbox":
                                        isParentQuestionAnswerRequireTheCurrentQuestionToBeAnswered = parentQuestion.cevap.split(";").includes(question.baglisecenek);
                                        break;
                                    default:
                                        isParentQuestionAnswerRequireTheCurrentQuestionToBeAnswered = false;
                                        break;
                                }

                                if (isParentQuestionAnswerRequireTheCurrentQuestionToBeAnswered && !isAnswered)
                                {
                                    isAllQuestionsAnswered = false;
                                    question.error = true;
                                }
                            }
                        }
                    }

                    if (!isAllQuestionsAnswered)
                    {
                        errors.push(self.$root.$i18n.t("EM_NeedToAnswersAllQuestions"));
                        errors.push(self.$root.$i18n.t("EM_TKaydetForContinueOnLater"));
                    }

                    const surveyCode = this.GetFormField('ksurveykod');

                    if (surveyCode == "IB" && !allowUnanswered)
                    {
                        const gorusSoru = self.KSurveyData.find(q => q.sorugrupadi === 'İş Birliğimizi Değerlendirme Görüşleri'); // UAT ve PROD'da sorugrupadi aynı olmalı
                        if (gorusSoru && gorusSoru.cevap.trim().length === 0)
                        {
                            let hasBadOrVeryBadAnswers = false;

                            for (const question of self.KSurveyData)
                            {
                                const isQuestionIsMandatory = Number(question.zorunlu);
                                if (isQuestionIsMandatory)
                                {
                                    if (question.sorugrupadi === 'İş Birliğimizi Değerlendirme Anketi' && // UAT ve PROD'da sorugrupadi aynı olmalı
                                        (question.cevap == "KÖTÜ" || question.cevap == "ÇOK KÖTÜ"))
                                    {
                                        hasBadOrVeryBadAnswers = true;
                                        break;
                                    }
                                }
                            }

                            if (hasBadOrVeryBadAnswers)
                            {
                                gorusSoru.error = true;
                                errors.push(self.$root.$i18n.t("EM_NeedToExplanationForBadOrVeryBadAnswers"));
                            }
                        }
                    }
                }

                self.errors = errors;
                return errors;
            },
            SetWhatToShowInStateAndLoadFormIfNecessary: function (self)
            {
                let loadFormData = false;
                const form = degerlendirme_formInfo.form;
                let formid = 0;
                const whatToShow = self.$route.name.replace(form, '');
                self.$store.commit('SetWhatToShow', { show: whatToShow });

                if (whatToShow == 'form')
                {
                    const params = self.$route.params;
                    if (params && params.id)
                    {
                        formid = Number(params.id);

                        if (formid > 0)
                        {
                            degerlendirme_formInfo.formid = formid;
                            loadFormData = true;
                        }

                    }
                }
                else if (whatToShow == 'yeni')
                {
                    loadFormData = true;
                    self.$store.commit('SetFormAndFormId', {
                        form,
                        formid
                    });
                }

                if (loadFormData)
                {
                    self.LoadFormData(formid);
                }
            }
        },

        mounted: function ()
        {
            var self = this;

            self.openallpanel = [0];
            self.$store.commit('updateFormInfo', degerlendirme_formInfo);

            self.SetWhatToShowInStateAndLoadFormIfNecessary(self);

            self.$store.dispatch('GetUserInfo').then(userInfo =>
            {
                self.username = userInfo.data.AdSoyad;
            });
        },
        computed: {
            FormAttributes: function ()
            {
                return this.GetFormAttributes;
            },
            UserName()
            {
                return this.GetUserName;
            },
            FormLoadingStatus: function ()
            {
                return this.GetFormLoadingStatus;
            },
            GetState: function ()
            {
                return this.$store.getters.GetFormState;
            },
        },
        watch: {
            $route: function (nval, oval)
            {
                this.SetWhatToShowInStateAndLoadFormIfNecessary(this);
            },
        }
    };
</script>
